<template>

    <v-chip
        class="person-label immutable-text"
        small
        label
        style="cursor: default!important"
    >
        <div
            class="if-more-tooltip-chip"
            v-tooltip.left-center="title"
        >    
            <i :class="['dark-gray-color']"></i>
            <div>{{ Title }}</div>
        </div>
        <div 
            class="pl-actions-wrapper"
        >
            <span
                v-if="!isReadOnly"
                v-tooltip.left-center="$t('Удалить')"
                @click="deleteRole()"
            >
                <i class="fas fa-trash dark-gray-color"></i>
            </span>
        </div>
    </v-chip>

</template>

<script>

export default {
    name: "RoleItem",
    data() {
        return {
            
        }
    },
    props: {
        type: {
            type: String,
            default: "email"
        },
        colWidth: {
            type: String,
            default: "3"
        },
        title: {
            type: String,
            default: null
        },
        IsActive: {
            type: Boolean,
            default: false
        },
        Progress: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        hideLoad: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        Title() {
            if (this.title.length > 40)
                return `${this.title.substring(0, 39)}...`;
            else
                return this.title;
        },
    },
    methods: {
        deleteRole()
        {
            this.$emit('deleterole', this.$vnode.key);
        }
    }
}
</script>